<template>
<div class="k-page-content">
        <el-tabs v-model="activeName" class="box-eltab">
            <el-tab-pane label="表单管理" name="first">
                <div class="k-page-common">
                    <div class="k-common-header">
                        <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
                            <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
                                <el-form-item label="表单名称">
                                    <el-input v-model="searchForm.fname" placeholder="请填写表单名称" clearable></el-input>
                                </el-form-item>
								<el-form-item label="数据表名称">
								    <el-input v-model="searchForm.sname" placeholder="请填写数据表名称" clearable></el-input>
								</el-form-item>
                                <el-form-item>
                                    <el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
                                    <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="k-common-con">
                        <div class="k-table-wrapper">
                            <div class="k-table-toolbar" style="margin-top:0;">
                                <div>
                                    <el-button type="primary" size="mini" @click="addFlowformOpen">添加表单</el-button>
                                </div>
                            </div>
                            <div class="k-table-con">
                                <el-table
                                    :data="tableData.data"
                                    style="width: 100%"
                                    row-key="id"
                                    border
                                    stripe
                                    ref = "table"
                                    highlight-current-row
                                    @sort-change="sortChange"
                                    :height="tableHeight">
                                <el-table-column
                                        fixed
                                        prop="fname"
                                        label="表单名称"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="sname"
                                        label="数据表名称"
                                        min-width="200">
                                </el-table-column>
                                <el-table-column
                                        prop="is_lock"
                                        label="是否可删除"
                                        min-width="140">
										<template slot-scope="scope">
										  <el-tag :size="size" v-if="scope.row.is_lock == '1'" type="success">可删除</el-tag>
										  <el-tag :size="size" v-if="scope.row.is_lock == '2'" type="danger">不可删除</el-tag>
										</template>
                                </el-table-column>
                                <el-table-column
                                        prop="fdesc"
                                        label="表单说明"
                                        min-width="220">
                                </el-table-column>
                                <el-table-column
                                        prop="create_time"
                                        label="创建时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        prop="update_time"
                                        label="修改时间"
                                        width="200"
                                        sortable="custom">
                                </el-table-column>
                                <el-table-column
                                        fixed="right"
                                        label="操作"
                                        min-width="100">
                                    <template slot-scope="scope">
                                        <el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size">编辑</el-button>
                                        <el-button v-if="scope.row.is_lock == 1" @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
							<el-pagination
								background
								ref="pagination"
								@current-change="handleCurrentChange"
								:current-page="tableData.page | number"
								:page-size="tableData.pagesize | number"
								layout="prev, pager, next, total"
								:total="tableData.total | number">
							</el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="addFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="130px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>添加表单</span>
                    <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
				<el-form-item label="表单名称" prop="fname">
					<el-input v-model="addForm.fname" placeholder="请填写表单名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="所属models名称" prop="models">
					<el-input v-model="addForm.models" placeholder="请填写所属models名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="数据表名称" prop="sname">
					<el-input v-model="addForm.sname" placeholder="请填写数据表名称" clearable></el-input>
				</el-form-item>
				<el-form-item label="表单说明" prop="fdesc">
					<el-input type="textarea" v-model="addForm.fdesc" placeholder="请填写表单说明" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="是否可删除" prop="is_lock">
					<el-radio v-model="addForm.is_lock" :label="1">可删除</el-radio>
					<el-radio v-model="addForm.is_lock" :label="2">不可删除</el-radio>
				</el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="addFlowform" :size='size'>提交</el-button>
                <el-button :size='size' @click="addFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
    
    <el-drawer
        custom-class="k-drawer"
        :visible.sync="editFormVisiable"
        direction="rtl"
        size="40%">
        <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="130px">
            <div class="drawer-header">
                <div class="header-title">
                    <span>编辑菜单</span>
                    <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
                </div>
            </div>
            <div class="drawer-content">
                <el-form-item label="表单名称" prop="fname">
                	<el-input v-model="editForm.fname" placeholder="请填写表单名称" clearable></el-input>
                </el-form-item>
				<el-form-item label="所属models名称" prop="models">
					<el-input v-model="editForm.models" placeholder="请填写所属models名称" clearable></el-input>
				</el-form-item>
                <el-form-item label="数据表名称" prop="sname">
                	<el-input v-model="editForm.sname" placeholder="请填写数据表名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="表单说明" prop="fdesc">
                	<el-input type="textarea" v-model="editForm.fdesc" placeholder="请填写表单说明" clearable>
                	</el-input>
                </el-form-item>
                <el-form-item label="是否可删除" prop="is_lock">
                	<el-radio-group v-model="editForm.is_lock">
                		<el-radio v-model="addForm.is_lock" :label="1">可删除</el-radio>
                		<el-radio v-model="addForm.is_lock" :label="2">不可删除</el-radio>
                	</el-radio-group>
                </el-form-item>
            </div>
            <div class="drawer-footer">
                <el-button type="primary" @click="editUser" :size='size'>提交</el-button>
                <el-button :size='size' @click="editFormVisiable = false">取消</el-button>
            </div>
        </el-form>
    </el-drawer>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
      return {
          addFormVisiable: false,
          editFormVisiable: false,
          checkSkVisiable: false,
          activeName: 'first',
          size:'mini',
          searchForm: {
              fname: '',
			  sname:''
          },
          resetSearch: {
              fname: '',
              sname:''
          },
          addForm: {
              sname: '',
			  models:'',
              fname: '',
              fdesc:'',
              is_lock:'2' //是否可删除，1可删除，2不可删除
          },
          editForm: {
              sname: '',
			  models:'',
              fname: '',
              fdesc:'',
              is_lock:''//是否可删除，1可删除，2不可删除
          },
          rules: {
              addForm: {
                  'fname': [
                      {required: true, message: '请填写表单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的表单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'sname': [
                      {required: true, max: 50, message: '请填写正确的数据表名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
				  'models': [
				      {required: true, max: 50, message: '请填写正确的models名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
                  'fdesc': [
                      {required: true, message: '请填写表单说明', trigger: ['change', 'blur']},
                      {max: 100, message: '请填写正确的表单说明，长度不超过 100', trigger: ['change', 'blur']}
                  ],
				  'is_lock': [
				      {required: true, message: '请选择是否可删除', trigger: ['change']}
				  ]
              },
              editForm: {
                  'menu_name': [
                      {required: true, message: '请填写菜单名称', trigger: ['change', 'blur']},
                      {max: 50, message: '请填写正确的菜单名称，长度不超过 50', trigger: ['change', 'blur']}
                  ],
				  'models': [
				      {required: true, max: 50, message: '请填写正确的models名称，长度不超过 50', trigger: ['change', 'blur']}
				  ],
                  'menu_icon': [
                      {required: true, max: 50, message: '请填写正确的菜单图标，长度不超过 50', trigger: ['change', 'blur']}
                  ],
                  'menu_sort': [
                      {required: true, type: 'number', min: 0, message: '请填写正确的排序', trigger: ['change', 'blur']}
                  ],
                  'is_lock': [
                      {required: true, message: '请选择是否可删除', trigger: ['change']}
                  ]
              }
          },
          tableData: {
              total: 0,
              pagesize: 15,
              page: 1,
              data: []
          }
      }
  },
  computed: {
      tableHeight: function () {
          return window.innerHeight - 320;
      }
  },
  mounted: function () {
      this.handleSearch(this.searchForm);
  },
  methods: {
		//列表查询
		handleSearch(params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/examine/flowform/list',param).then(res => {
			   if (res.code == 0) {
				   this.tableData = res.data;		
			   }else{
				   this.$message({
					   showClose: true,
					   message: res.msg,
					   type: 'warning'
				   });
			   }
			})
		},
		// 执行查询
		doSearch() {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset() {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange(e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
			  order = 'asc';
			} else if (e.order == 'descending') {
			  order = 'desc';
			} else {
			  prop = this.resetSearch.prop;
			  order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange(val) {
			this.handleSearch(this.searchForm, val);
		},
		// 添加菜单弹窗
		addFlowformOpen(){
			this.addForm = {
              sname: '',
              fname: '',
              fdesc:'',
              is_lock:2
          },
			this.addFormVisiable = true;
		},
		// 添加表单
		addFlowform() {
		  this.$refs['addForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.post('/admin/examine/flowform/add',this.addForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '表单添加成功！',
							  type: 'success'
						  });
						  this.addFormVisiable = false;
					  } else {
						 this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
		
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
		  }.bind(this));
		},
		//编辑弹窗
		handleTableEditOpen(row){
			this.$api.get('/admin/examine/flowform/info',{id:row.id}).then(res => {
				  if (res.code == 0) {
					  this.editForm = res.data
					  this.editFormVisiable = true;
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			})
		},
		//编辑
		editUser(){
			this.$refs['editForm'].validate(function (valid) {
			  if (valid) {
				  this.loading = true;
				  this.$api.put('/admin/examine/flowform/edit',this.editForm).then(res => {
					  if (res.code === 0) {
						  // 重新加载表格
						  this.handleSearch();
						  this.$message({
							  showClose: true,
							  message: '表单信息修改成功！',
							  type: 'success'
						  });
						  this.editFormVisiable = false;
					  } else {
						  this.$message.error(res.msg);
					  }
					  this.loading = false
				  })
			  } else {
				  this.$message({
					  showClose: true,
					  message: '请填写正确的信息！',
					  type: 'warning'
				  });
			  }
			}.bind(this));
		},
		//删除
		handleTableDelete(row){
			this.$confirm('此操作将永久删除该表单, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(function() {
			  this.loading = true;
			  this.$api.delete('/admin/examine/flowform/del', {id:row.id}).then(res => {
				  if (res.code == 0) {
					  var data = this.tableData.data;
					  data.forEach(function (item, index) {
						  if (item.id == row.id) {
							  this.$delete(data, index);
						  } else if (item.children) {
							  item.children.forEach(function (value, key) {
								  if (value.id == row.id) {
									  this.$delete(item.children, key);
								  }
							  }.bind(this));
						  }
					  }.bind(this));
					  this.$message({
						  showClose: true,
						  message: '该表单已成功删除！',
						  type: 'success'
					  });
				  } else {
					  this.$message.error(res.msg);
				  }
				  this.loading = false
			  })
			}.bind(this))
		}
    }
}
</script>